import $ from 'jquery';

$(function () {
   if ($('#loan_programs_page').length  ) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#fha_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#conv_lp_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#hr_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#hp_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#jumbo_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#renovation_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#usda_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    if ($('#va_loan_page').length) {
        if ($('.nav-tabs-cmg').length) {
            updateSelectAndTabs();

            $('.nav-tabs-cmg .nav-tabs-mobile select').on('change', function () {
                updateSelectAndTabs(this.value);
            });
        }
    }
    function updateSelectAndTabs(selectedValue) {
        var $mobileSelect = $('.nav-tabs-cmg .nav-mobile select');
        var fontSize = $mobileSelect.css('font-size');
        var fontFamily = $mobileSelect.css('font-family');
        var fontWeight = $mobileSelect.css('font-weight');

        var $temp = $('<div style="position: absolute; left: -900px"></div>');
        $temp.appendTo('body');
        $temp.css({ 'font-size': fontSize, 'font-family': fontFamily, 'font-weight': fontWeight });
        $temp.text($mobileSelect.find(':selected').text());

        $mobileSelect.width(Math.round($temp.width()) + 20);
        $temp.remove();

        if (selectedValue) {
            var link = document.getElementById(selectedValue);
            var event = document.createEvent('HTMLEvents');
            event.initEvent('click', true, true);
        }
    }
});